import '@/styles/main.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vSelect from 'vue-select'
import VueSlideBar from 'vue-slide-bar'
import VueI18n from 'vue-i18n'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueTreeList from 'vue-tree-list'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import DatePicker from 'vue2-datepicker'
import { VueEditor, Quill } from "vue2-editor"
import ImageResize from "quill-image-resize-vue";
import VideoResize from 'quill-video-resize-module2'

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

//Components
import textLined from './components/textLined'
import textLinedCenter from './components/textLinedCenter'

//axios to prototype
Vue.prototype.$axios = axios;
//token in all request headers
const token = localStorage.token;
if (token) {
  Vue.prototype.$axios.defaults.headers.common['Authorization'] = `${token}`;
}

//libs
Vue.use(VueAxios, axios);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(VueI18n);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API,
    libraries: 'places'
  }
});
Vue.use(VueTreeList);
Vue.use(PerfectScrollbar);

//global components
Vue.component('datepicker', DatePicker);
Vue.component('v-select', vSelect);
Vue.component('VueSlideBar', VueSlideBar)
Vue.component('text-lined', textLined);
Vue.component('text-lined-center', textLinedCenter);
Vue.component('vue-editor', VueEditor)

Quill.register("modules/imageResize", ImageResize);
Quill.register('modules/VideoResize', VideoResize)

Vue.config.productionTip = false;

import ru from './langs/ru'
import en from './langs/en'

const i18n = new VueI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: {
    'ru': ru,
    'en': en
  }
});

new Vue({
  i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app');
